'use client';

export default function CopyrightFooter() {
  return (
    <div className='border-border mt-4 border-t pt-4 text-center lg:mt-8'>
      <p className='text-muted-foreground px-4 text-xs'>
        © {new Date().getFullYear()} TAJ ALSAFA® Real Estate Development. All
        rights reserved.
        {/* <br /> */}
        Developed and Administered by R&D Department
      </p>
    </div>
  );
}
